import React, { PropTypes } from 'react';
import SocialIcon from 'components/Icons/social-icon';

const Social = (props) => {
    return (
        <div className="social">
          <h4>Connect with me</h4>
          <div className="social-icons">
            <SocialIcon url="https://medium.com/@drkiandra" network="medium"/>
            <SocialIcon url="https://www.youtube.com/channel/UCPdZ-BNcBNkcPcohdEJi12A" network="youtube"/>
            <SocialIcon url="https://www.facebook.com/profile.php?id=100012010306437" network="facebook"/>
            <SocialIcon url="https://twitter.com/drkiandra" network="twitter"/>
          </div>
        </div>
    );
};

export default Social;



/** WEBPACK FOOTER **
 ** ./src/components/Social.js
 **/